'use strict';

export function initializeResponsiveMenu() {
  const navigation = document.querySelector('.page-header__menu'); // Główne menu
  let toggleButton = null; // Przycisk mobilnego menu
  let isMobile = false; // Flaga określająca tryb (desktop/mobilny)

  // Funkcja zmieniająca menu na mobilne
  const enableMobileMenu = () => {
    if (isMobile) return; // Jeśli menu mobilne już jest aktywne, zakończ

    // Dodaj klasę mobilnego menu
    navigation.classList.add('page-header__menu-mobile');
    navigation.classList.remove('page-header__menu');

    // Utwórz przycisk otwierający/zamykający menu
    toggleButton = document.createElement('button');
    toggleButton.id = 'menu-toggle';
    toggleButton.setAttribute('aria-expanded', 'false');
    toggleButton.setAttribute('aria-label', 'Otwórz menu');
    toggleButton.setAttribute('aria-controls', 'page-header__menu');
    let span = document.createElement('span');
    toggleButton.appendChild(span);
    span = document.createElement('span');
    toggleButton.appendChild(span);
    span = document.createElement('span');
    toggleButton.appendChild(span);
    span = document.createElement('span');
    toggleButton.appendChild(span);
    span = document.createElement('span');
    toggleButton.appendChild(span);
    span = document.createElement('span');
    toggleButton.appendChild(span);

    // Wstaw przycisk przed listą nawigacyjną
    navigation.insertBefore(
      toggleButton,
      navigation.querySelector('ul.main-menu')
    );

    // Dodaj obsługę kliknięcia przycisku
    toggleButton.addEventListener('click', () => {
      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      toggleButton.setAttribute('aria-expanded', !isExpanded);
      const mainMenu = navigation.querySelector('ul.main-menu');
      mainMenu.setAttribute('aria-hidden', isExpanded);
      mainMenu.style.display = isExpanded ? 'none' : 'block';

      if (!isExpanded) {
        document.addEventListener('keydown', handleEscKey); // Obsługa Esc
        document.addEventListener('click', handleClickOutside); // Obsługa kliknięcia poza menu
      } else {
        document.removeEventListener('keydown', handleEscKey);
        document.removeEventListener('click', handleClickOutside);
      }
    });

    // Dodaj atrybuty ARIA do listy głównej
    const mainMenu = navigation.querySelector('ul.main-menu');
    mainMenu.setAttribute('aria-hidden', 'true');
    mainMenu.style.display = 'none';

    isMobile = true; // Ustaw flagę mobilnego menu
  };

  // Funkcja przywracająca menu do stanu pierwotnego (desktop)
  const disableMobileMenu = () => {
    if (!isMobile) return; // Jeśli menu mobilne nie jest aktywne, zakończ

    // Przywróć pierwotną klasę
    navigation.classList.remove('page-header__menu-mobile');
    navigation.classList.add('page-header__menu');

    // Usuń przycisk otwierania/zamykania
    if (toggleButton) {
      toggleButton.remove();
      toggleButton = null;
    }

    // Przywróć widoczność listy głównej i usuń atrybuty ARIA
    const mainMenu = navigation.querySelector('ul.main-menu');
    mainMenu.removeAttribute('aria-hidden');
    mainMenu.style.display = '';

    document.removeEventListener('keydown', handleEscKey);
    document.removeEventListener('click', handleClickOutside);

    isMobile = false; // Zresetuj flagę mobilnego menu
  };

  // Funkcja reagująca na zmianę rozmiaru okna
  const handleResize = () => {
    if (document.documentElement.clientWidth <= 1400) {
      enableMobileMenu(); // Przejdź na menu mobilne
    } else {
      disableMobileMenu(); // Przywróć menu desktopowe
    }
  };

  // Obsługa klawisza Esc do zamykania menu
  const handleEscKey = event => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  };

  // Obsługa kliknięcia poza menu do jego zamykania
  const handleClickOutside = event => {
    const mainMenu = navigation.querySelector('ul.main-menu');
    if (
      isMobile &&
      toggleButton.getAttribute('aria-expanded') === 'true' &&
      !navigation.contains(event.target)
    ) {
      closeMenu();
    }
  };

  // Funkcja zamykająca menu
  const closeMenu = () => {
    if (!toggleButton || !isMobile) return;
    toggleButton.setAttribute('aria-expanded', 'false');
    const mainMenu = navigation.querySelector('ul.main-menu');
    mainMenu.setAttribute('aria-hidden', 'true');
    mainMenu.style.display = 'none';

    document.removeEventListener('keydown', handleEscKey);
    document.removeEventListener('click', handleClickOutside);
  };

  // Nasłuchiwanie zmian rozmiaru okna
  window.addEventListener('resize', handleResize);

  // Inicjalizacja menu na podstawie początkowej szerokości okna
  handleResize();
}
